module.exports = __webpack_public_path__ + "9-summer-snow.5f223501e5740a5fc26a.png";


//////////////////
// WEBPACK FOOTER
// D:/projects/4164_AppsPotr_Backend/production/CMS_prod/src/assets/images/festival/9-summer-snow.png
// module id = ../../../../../src/assets/images/festival/9-summer-snow.png
// module chunks = styles